import { render } from "./student-linked-accounts.vue?vue&type=template&id=319c6f1f"
import script from "./student-linked-accounts.vue?vue&type=script&lang=js"
export * from "./student-linked-accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__